import React from 'react';
import {
  MDBCol,
  MDBBtn,
  MDBInput,
  MDBModal,
  MDBNavLink,
  MDBModalFooter,
  MDBModalBody,
  MDBModalHeader,
  MDBDataTable,
  MDBListGroup, MDBListGroupItem,
  MDBContainer, MDBInputGroup
} from 'mdbreact';
import './statementTemplate-view.css';
import Fab from '@material-ui/core/Fab';
import AddIcon from '@material-ui/icons/Add';
import { Redirect, Link } from "react-router-dom";
import SpinnerView from '../../components/spinner/spinner-view';
import Breadcrumb from '../../components/breadcrumb';

class HomeView extends React.Component {

  state = {
    statementTemplate: {},
    compiled:''
  }

  handleChange = (value, prop) => {
    var t = this.state.statementTemplate;
/*
    hb.registerHelper('dateFormat', function (date, options) {
      const formatToUse = (arguments[1] && arguments[1].hash && arguments[1].hash.format) || "YYYY-MM-DD"
      return moment(date).format(formatToUse);
  });

    const template = hb.compile(value, { strict: false });
    let c = t;

    if(prop =='template') {
      try{
        c =template({});
      }
      catch {
       
      }
    }
    */
     t[prop] = value;
    this.setState({
      statementTemplate: t,
     // compiled: c
    });
  }

  componentDidMount() {
    this.props.getStatementTemplate(this.props.match.params.id);
  }

  componentWillUpdate(props, state) {
    if (props.statementTemplate && state.statementTemplate) {
      if (state.statementTemplate._id != props.statementTemplate._id) {
        this.setState({
          statementTemplate: props.statementTemplate,
          //compiled: props.statementTemplate.template
        });
      }
    }

    return true;
  }

  save = () => {
      this.props.saveStatementTemplate(this.state.statementTemplate);
  }

  scrollToTop = () => window.scrollTo(0, 0);

  render() {
    if (this.props.user && !this.props.user._id) {
      return <Redirect to='/' />
    }

   console.log(this.state.statementTemplate);

    return (
      <div className="content-wrapper pl-4 pr-4">
      <SpinnerView showSpinner={this.props.loading} />

      <Breadcrumb title={'Statement Templates'} />
        {this.state.statementTemplate && <MDBInput label="statementTemplateName" onChange={(e) => this.handleChange(e.target.value, 'statementTemplateName')} group type="text" value={this.state.statementTemplate.statementTemplateName} />}

        {this.state.statementTemplate && <div class="form-group green-border-focus">
          <label for="exampleFormControlTextarea5">statementTemplateEmailBody</label>
          <textarea class="form-control" id="exampleFormControlTextarea5" onChange={(e) => this.handleChange(e.target.value, 'statementTemplateEmailBody')} value={this.state.statementTemplate.statementTemplateEmailBody}  rows="3"></textarea>
        </div>}

        {this.state.statementTemplate && this.state.statementTemplate.statementTemplateEmailBody && <div dangerouslySetInnerHTML={{__html: this.state.statementTemplate.statementTemplateEmailBody.replace(/(<script)/gi, 'illegalscript')}} ></div>}

        {this.state.statementTemplate && <div class="form-group green-border-focus">
          <label for="exampleFormControlTextarea5">Template</label>
          <textarea class="form-control" id="exampleFormControlTextarea5" onChange={(e) => this.handleChange(e.target.value, 'template')} value={this.state.statementTemplate.template}  rows="3"></textarea>
        </div>}

        {this.state.statementTemplate && this.state.statementTemplate.template && <div dangerouslySetInnerHTML={{__html: this.state.statementTemplate.template.replace(/(<script)/gi, 'illegalscript')}} ></div>}

        <MDBBtn  onClick={this.save} color="primary">Save</MDBBtn>

      </div>
    );
  }
}

export default HomeView;
